import d3, { lab } from "d3";
const removeGooglebanner = () => {
    let element2 = document.querySelectorAll("iframe.skiptranslate");
    // let element = document.getElementById(":2.container"); this works!!
    // console.log("3333", element);

    if (element2?.length > 0) {
        if (element2[0].title === "") {
            element2[0].style.display = "none";
            // element2[0].style.display = "absolute"; // to debug
            // element2[0].style.top = "250px"; // to debug
        }
    }
};
export const showOriginalText = () => {
    // sessionStorage.setItem("googleTranslate", true);

    // let iframe = d3.select("iframe.goog-te-banner-frame").node();
    // iframe &&
    //     d3
    //         .select(iframe.contentDocument)
    //         .selectAll(".goog-te-button button")
    //         .each(function () {
    //             if (this.innerHTML === "Show original") this.click();
    //         });

    let element2 = document.querySelectorAll("iframe.skiptranslate");
    if (element2.length > 0) {
        let extractLangNode = [];
        element2.forEach((obj) => {
            let anchorTagLists = obj.contentWindow.document.querySelectorAll("a");
            if (anchorTagLists?.length == 3) extractLangNode.push(obj);
        });

        element2 = extractLangNode[0];

        if (extractLangNode?.length == 1) {
            element2.contentWindow.document.querySelectorAll("button").forEach((e) => {
                // console.log("buttons", e, e.innerHTML, e.innerHTML === "Show original");
                // console.log(e.innerHTML, e.id);
                if (e.id?.includes("restore") || e.innerHTML === "Show original" || e.innerHTML === "Tampilkan dalam bahasa asli") e.click();
            });
            element2.contentWindow.document.querySelectorAll("a").forEach((e) => {
                if (e.title === "Close") e.click();
            });
        }
    }
};

const langCode = {
    en: "English",
    de: "German",
    ja: "Japanese",
    id: "Indonesian",
    es: "Spanish",
    ar: "Arabic",
    my: "Myanmar (Burmese)",
    "zh-TW": "Chinese (Traditional)",
    th: "Thai",
    ms: "Malay",
    tl: "Filipino",
    vi: "Vietnamese",
};

const langListWithCode = {
    en: ["english", "inggris"],
    de: ["german", "jerman"],
    ja: ["japanese", "jepang"],
    id: ["indonesian", "indonesia"],
    es: ["spanish", "spanyol"],
    ar: ["arabic", "arab"],
    my: ["myanmar (burmese)", "burma"],
    "zh-TW": ["chinese (traditional)", "china (aks. tradisional)"],
    th: ["thai"],
    ms: ["malay", "melayu"],
    tl: ["filipino", "tagalog"],
    vi: ["vietnamese", "vietnam"],
};

export const languageOptions = [
    { key: "Arabic", text: "Arabic", label: "Arabic", value: "ar" },
    { key: "Chinese (Traditional)", text: "Chinese (Traditional)", label: "Chinese (Traditional)", value: "zh-TW" },
    { key: "English", text: "English", label: "English", value: "en" },
    { key: "Filipino", text: "Filipino", label: "Filipino", value: "tl" },
    { key: "German", text: "German", label: "German", value: "de" },
    { key: "Indonesian", text: "Indonesian", label: "Indonesian", value: "id" },
    { key: "Japanese", text: "Japanese", label: "Japanese", value: "ja" },
    { key: "Malay", text: "Malay", label: "Malay", value: "ms" },
    { key: "Myanmar (Burmese)", text: "Myanmar (Burmese)", label: "Myanmar (Burmese)", value: "my" },
    { key: "Spanish", text: "Spanish", label: "Spanish", value: "es" },
    { key: "Thai", text: "Thai", label: "Thai", value: "th" },
    { key: "Vietnamese", text: "Vietnamese", label: "Vietnamese", value: "vi" },
];

export const changeLanguage = (lang) => {
    // setCookie('googtrans', lang, 1, '/; samesite=none')
    sessionStorage.setItem("selectedLanguage", lang);
    sessionStorage.setItem("googleTranslate", true);
    applyChangedLanguage(lang);
};

export const applyChangedLanguage = (lang) => {
    let element2 = document.querySelectorAll("iframe.skiptranslate");
    // console.log("optionsssss", element2);
    if (element2.length !== 0) {
        if (element2?.length === 1) element2 = element2[0];
        else {
            let extractLangNode = [];
            element2.forEach((obj) => {
                let anchorTagLists = obj.contentWindow.document.querySelectorAll("a");
                // console.log("link options-", anchorTagLists);
                if (anchorTagLists?.length > 11) extractLangNode.push(obj);
            });
            element2 = extractLangNode?.length > 0 ? extractLangNode[0] : element2[element2.length - 2];
        }
        // console.log("elements", element2);
        element2.contentWindow.document.querySelectorAll("a").forEach((e) => {
            // console.log("hereeee", e.children[0]?.lastChild?.innerHTML?.toLowerCase(), langListWithCode[lang]?.includes(language), langListWithCode[lang]);
            const language = e.children[0]?.lastChild?.innerHTML?.toLowerCase().trim();
            // console.log("hereeee", language, langListWithCode[lang]?.includes(language), langListWithCode[lang]);

            // if (e.children[0]?.lastChild?.innerHTML?.toLowerCase() === langCode[lang]?.toLowerCase()) {
            if (language === langCode[lang]?.toLowerCase() || langListWithCode[lang]?.includes(language)) {
                e.click(); // click to translate lang
                removeGooglebanner();

                setTimeout(() => {
                    removeGooglebanner();
                }, 300);
            }
        });
    } else {
        setTimeout(() => {
            // console.log("google translate iframes not found");
            applyChangedLanguage();
        }, 2000);
    }

    // if (d3.select("iframe.goog-te-menu-frame").node())
    //     d3.select(d3.select("iframe.goog-te-menu-frame").node().contentDocument)
    //         .selectAll(".goog-te-menu2-item span.text")
    //         .each(function () {
    //             if (this.innerHTML === langCode[lang]) this.click();
    //         });
};

const getCookieValue = () => {
    // var transCookie = getCookie('googtrans');
    var transCookie = sessionStorage.getItem("selectedLanguage");
    if (transCookie) {
        transCookie = transCookie.split("/");
        transCookie = transCookie[2];
        return transCookie;
    }
    return false;
};

const getCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
};

const setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
};

export const clearTranslate = () => {
    // setCookie('googtrans', null, 1, '/; samesite=none')
    showOriginalText();
    sessionStorage.setItem("selectedLanguage", null);
    sessionStorage.setItem("googleTranslate", false);
};
